export interface ITimezoneCode {
	id: string;
	name: string;
}

export const TimezoneCodes: ITimezoneCode[] = [
	{ id: 'Dateline Standard Time', name: '(UTC-12:00) International Date Line West' },
	{ id: 'UTC-11', name: '(UTC-11:00) Coordinated Universal Time-11' },
	{ id: 'Hawaiian Standard Time', name: '(UTC-10:00) Hawaii' },
	{ id: 'Alaskan Standard Time', name: '(UTC-09:00) Alaska' },
	{ id: 'Pacific Standard Time (Mexico)', name: '(UTC-08:00) Baja California' },
	{ id: 'Pacific Standard Time', name: '(UTC-08:00) Pacific Time (US & Canada)' },
	{ id: 'US Mountain Standard Time', name: '(UTC-07:00) Arizona' },
	{ id: 'Mountain Standard Time (Mexico)', name: '(UTC-07:00) Chihuahua, La Paz, Mazatlan' },
	{ id: 'Mountain Standard Time', name: '(UTC-07:00) Mountain Time (US & Canada)' },
	{ id: 'Central America Standard Time', name: '(UTC-06:00) Central America' },
	{ id: 'Central Standard Time', name: '(UTC-06:00) Central Time (US & Canada)' },
	{ id: 'Central Standard Time (Mexico)', name: '(UTC-06:00) Guadalajara, Mexico City, Monterrey' },
	{ id: 'Canada Central Standard Time', name: '(UTC-06:00) Saskatchewan' },
	{ id: 'SA Pacific Standard Time', name: '(UTC-05:00) Bogota, Lima, Quito' },
	{ id: 'Eastern Standard Time', name: '(UTC-05:00) Eastern Time (US & Canada)' },
	{ id: 'US Eastern Standard Time', name: '(UTC-05:00) Indiana (East)' },
	{ id: 'Venezuela Standard Time', name: '(UTC-04:30) Caracas' },
	{ id: 'Paraguay Standard Time', name: '(UTC-04:00) Asuncion' },
	{ id: 'Atlantic Standard Time', name: '(UTC-04:00) Atlantic Time (Canada)' },
	{ id: 'Central Brazilian Standard Time', name: '(UTC-04:00) Cuiaba' },
	{ id: 'SA Western Standard Time', name: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan' },
	{ id: 'Pacific SA Standard Time', name: '(UTC-04:00) Santiago' },
	{ id: 'Newfoundland Standard Time', name: '(UTC-03:30) Newfoundland' },
	{ id: 'E. South America Standard Time', name: '(UTC-03:00) Brasilia' },
	{ id: 'Argentina Standard Time', name: '(UTC-03:00) Buenos Aires' },
	{ id: 'SA Eastern Standard Time', name: '(UTC-03:00) Cayenne, Fortaleza' },
	{ id: 'Greenland Standard Time', name: '(UTC-03:00) Greenland' },
	{ id: 'Montevideo Standard Time', name: '(UTC-03:00) Montevideo' },
	{ id: 'Bahia Standard Time', name: '(UTC-03:00) Salvador' },
	{ id: 'UTC-02', name: '(UTC-02:00) Coordinated Universal Time-02' },
	{ id: 'Mid-Atlantic Standard Time', name: '(UTC-02:00) Mid-Atlantic' },
	{ id: 'Azores Standard Time', name: '(UTC-01:00) Azores' },
	{ id: 'Cape Verde Standard Time', name: '(UTC-01:00) Cape Verde Is.' },
	{ id: 'Morocco Standard Time', name: '(UTC) Casablanca' },
	{ id: 'UTC', name: '(UTC) Coordinated Universal Time' },
	{ id: 'GMT Standard Time', name: '(UTC) Dublin, Edinburgh, Lisbon, London' },
	{ id: 'Greenwich Standard Time', name: '(UTC) Monrovia, Reykjavik' },
	{ id: 'W. Europe Standard Time', name: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna' },
	{ id: 'Central Europe Standard Time', name: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague' },
	{ id: 'Romance Standard Time', name: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris' },
	{ id: 'Central European Standard Time', name: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb' },
	{ id: 'W. Central Africa Standard Time', name: '(UTC+01:00) West Central Africa' },
	{ id: 'Namibia Standard Time', name: '(UTC+01:00) Windhoek' },
	{ id: 'GTB Standard Time', name: '(UTC+02:00) Athens, Bucharest' },
	{ id: 'Middle East Standard Time', name: '(UTC+02:00) Beirut' },
	{ id: 'Egypt Standard Time', name: '(UTC+02:00) Cairo' },
	{ id: 'Syria Standard Time', name: '(UTC+02:00) Damascus' },
	{ id: 'E. Europe Standard Time', name: '(UTC+02:00) E. Europe' },
	{ id: 'South Africa Standard Time', name: '(UTC+02:00) Harare, Pretoria' },
	{ id: 'FLE Standard Time', name: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius' },
	{ id: 'Turkey Standard Time', name: '(UTC+02:00) Istanbul' },
	{ id: 'Israel Standard Time', name: '(UTC+02:00) Jerusalem' },
	{ id: 'Jordan Standard Time', name: '(UTC+03:00) Amman' },
	{ id: 'Arabic Standard Time', name: '(UTC+03:00) Baghdad' },
	{ id: 'Kaliningrad Standard Time', name: '(UTC+03:00) Kaliningrad, Minsk' },
	{ id: 'Arab Standard Time', name: '(UTC+03:00) Kuwait, Riyadh' },
	{ id: 'E. Africa Standard Time', name: '(UTC+03:00) Nairobi' },
	{ id: 'Iran Standard Time', name: '(UTC+03:30) Tehran' },
	{ id: 'Arabian Standard Time', name: '(UTC+04:00) Abu Dhabi, Muscat' },
	{ id: 'Azerbaijan Standard Time', name: '(UTC+04:00) Baku' },
	{ id: 'Russian Standard Time', name: '(UTC+04:00) Moscow, St. Petersburg, Volgograd' },
	{ id: 'Mauritius Standard Time', name: '(UTC+04:00) Port Louis' },
	{ id: 'Georgian Standard Time', name: '(UTC+04:00) Tbilisi' },
	{ id: 'Caucasus Standard Time', name: '(UTC+04:00) Yerevan' },
	{ id: 'Afghanistan Standard Time', name: '(UTC+04:30) Kabul' },
	{ id: 'Pakistan Standard Time', name: '(UTC+05:00) Islamabad, Karachi' },
	{ id: 'West Asia Standard Time', name: '(UTC+05:00) Tashkent' },
	{ id: 'India Standard Time', name: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi' },
	{ id: 'Sri Lanka Standard Time', name: '(UTC+05:30) Sri Jayawardenepura' },
	{ id: 'Nepal Standard Time', name: '(UTC+05:45) Kathmandu' },
	{ id: 'Central Asia Standard Time', name: '(UTC+06:00) Astana' },
	{ id: 'Bangladesh Standard Time', name: '(UTC+06:00) Dhaka' },
	{ id: 'Ekaterinburg Standard Time', name: '(UTC+06:00) Ekaterinburg' },
	{ id: 'Myanmar Standard Time', name: '(UTC+06:30) Yangon (Rangoon)' },
	{ id: 'SE Asia Standard Time', name: '(UTC+07:00) Bangkok, Hanoi, Jakarta' },
	{ id: 'N. Central Asia Standard Time', name: '(UTC+07:00) Novosibirsk' },
	{ id: 'China Standard Time', name: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi' },
	{ id: 'North Asia Standard Time', name: '(UTC+08:00) Krasnoyarsk' },
	{ id: 'Singapore Standard Time', name: '(UTC+08:00) Kuala Lumpur, Singapore' },
	{ id: 'W. Australia Standard Time', name: '(UTC+08:00) Perth' },
	{ id: 'Taipei Standard Time', name: '(UTC+08:00) Taipei' },
	{ id: 'Ulaanbaatar Standard Time', name: '(UTC+08:00) Ulaanbaatar' },
	{ id: 'North Asia East Standard Time', name: '(UTC+09:00) Irkutsk' },
	{ id: 'Tokyo Standard Time', name: '(UTC+09:00) Osaka, Sapporo, Tokyo' },
	{ id: 'Korea Standard Time', name: '(UTC+09:00) Seoul' },
	{ id: 'Cen. Australia Standard Time', name: '(UTC+09:30) Adelaide' },
	{ id: 'AUS Central Standard Time', name: '(UTC+09:30) Darwin' },
	{ id: 'E. Australia Standard Time', name: '(UTC+10:00) Brisbane' },
	{ id: 'AUS Eastern Standard Time', name: '(UTC+10:00) Canberra, Melbourne, Sydney' },
	{ id: 'West Pacific Standard Time', name: '(UTC+10:00) Guam, Port Moresby' },
	{ id: 'Tasmania Standard Time', name: '(UTC+10:00) Hobart' },
	{ id: 'Yakutsk Standard Time', name: '(UTC+10:00) Yakutsk' },
	{ id: 'Central Pacific Standard Time', name: '(UTC+11:00) Solomon Is., New Caledonia' },
	{ id: 'Vladivostok Standard Time', name: '(UTC+11:00) Vladivostok' },
	{ id: 'New Zealand Standard Time', name: '(UTC+12:00) Auckland, Wellington' },
	{ id: 'UTC+12', name: '(UTC+12:00) Coordinated Universal Time+12' },
	{ id: 'Fiji Standard Time', name: '(UTC+12:00) Fiji' },
	{ id: 'Magadan Standard Time', name: '(UTC+12:00) Magadan' },
	{ id: 'Kamchatka Standard Time', name: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old' },
	{ id: 'Tonga Standard Time', name: '(UTC+13:00) Nukualofa' },
	{ id: 'Samoa Standard Time', name: '(UTC+13:00) Samoa' }
];
